/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { searchTracker } from '../../actions/universalTracker';
import { UtrValueType } from '../../types/universalTracker';
import { ValueTable } from '../survey/form/input/table/InputInterface';
import SearchComponent, { Suggestion } from './SearchComponent';

interface ValueListOption {
  code: string;
  name: string;
}

interface ValueList {
  _id: string;
  code: string;
  created: string;
  name: string;
  options: ValueListOption[];
}

export interface UTRSuggestion extends Suggestion {
  valueLabel: string;
  code: string;
  valueType: UtrValueType;
  valueValidation: {
    min: null | number;
    max: null | number;
    valueList?: {
      type: 'custom' | 'list',
      custom?: ValueListOption[];
    };
    table?: ValueTable;
  };
  valueListOptions?: null | ValueList;
}

const renderSuggestion = (suggestion: Partial<UTRSuggestion>) => {
  return (
    <div className='suggestion-item'>
      <span>
        <div>{suggestion.name}</div>
      </span>
    </div>
  );
}

interface UTRSearchProps {
  placeholder: string;
  handleValueChange: (searchStr: string, currentSuggestion?: UTRSuggestion) => void;
  inputClassName?: string;
  filter?: {
    valueType: UtrValueType[]
  };
  initiativeId?: string;
}

export const UTRSearch = (props: UTRSearchProps) => {
  const valueChange = (searchStr: string, currentSuggestion?: Suggestion) => props.handleValueChange(searchStr, currentSuggestion as UTRSuggestion);

  return (
    <SearchComponent
      {...props}
      handleValueChange={valueChange}
      searchAction={(search) => searchTracker(search, props.filter, props.initiativeId)}
      renderSuggestion={renderSuggestion}
    />
  );
}

export default UTRSearch;
